import { BasePage } from "../base/base";
import { ResponsiveGrid } from "../components/grid";
import { IconLink } from "../components/iconLink";
import { FaGithubAlt } from "react-icons/fa";
import { SiDevpost } from "react-icons/si";
import { PiMatrixLogoFill } from "react-icons/pi";
import { BsMailbox2 } from "react-icons/bs";

const AboutPage = () => {
  return (
    <BasePage>
      <h1>About Page</h1>
      <p> 🚧 under construction 🚧 </p>

      <ResponsiveGrid>
        <IconLink
          key="0"
          icon={<FaGithubAlt size={"3rem"} />}
          to={"https://github.com/lstuma/"}
          size={"3rem"}
        />
        <IconLink
          key="1"
          icon={<SiDevpost size={"3rem"} />}
          to={"https://devpost.com/lstuma"}
          size={"3rem"}
        />
        <IconLink
          key="2"
          icon={<PiMatrixLogoFill size={"3rem"} />}
          to={"https://lstuma.dev"}
          size={"3rem"}
        />
        <IconLink
          key="3"
          icon={<BsMailbox2 size={"3rem"} />}
          to={"mailto:lstuma@lstuma.dev"}
          size={"3rem"}
        />
      </ResponsiveGrid>
    </BasePage>
  );
};

export { AboutPage };
